import { atom } from 'recoil';
import { FirebaseDataStatus } from '~/types/utilities';

const authStatus = atom<FirebaseDataStatus>({
  key: 'authStatus',
  default: FirebaseDataStatus.INIT,
});

export default authStatus;
